import isEmpty from "lodash/isEmpty";
import actionTypes from "./actionTypes";
import api from "./api";
import { getActionLogEventTypeDictionary } from "./selectors";
export default {
    setActionLogType: (actionLogType) => ({
        type: actionTypes.SET_ACTION_LOG_TYPE,
        actionLogType
    }),
    export: (type, filter, sort) => ({
        type: actionTypes.EXPORT,
        payload: {
            promise: () => api.export(type, filter, sort)
        }
    }),
    getActionLogEventTypeDictionary: () => (dispatch, getState) => isEmpty(getActionLogEventTypeDictionary(getState())) &&
        dispatch({
            type: actionTypes.GET_ACTION_LOG_EVENT_TYPE_DICTIONARY,
            payload: {
                promise: () => api.getActionLogEventTypeDictionary()
            }
        }),
    getActionLogUsers: () => ({
        type: actionTypes.GET_ACTION_LOG_USERS,
        payload: {
            promise: () => api.getActionLogUsers()
        }
    }),
    getActionLogProjects: () => ({
        type: actionTypes.GET_ACTION_LOG_PROJECTS,
        payload: {
            promise: () => api.getActionLogProjects()
        }
    })
};
